<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv" *ngIf="!isVisible">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
              <p-multiSelect [filter]="true" [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multiselectStatuses" placeholder="Sel. Status"
                [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1" id="refreshBatchesDiv">
            <button pButton class="refreshBatches" *ngIf="checkQCScan()" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv" [hidden]="isVisible">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Protocol"></button>
              <p-multiSelect [options]="protocolsList" name="processFlowsList" (onChange)="onApplyFilter()"
                [(ngModel)]="selectedProtocolList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multiselectStatuses"
                placeholder="Sel. Protocol" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 pt-2" id="refreshBatchesDiv">
            <button pButton class="refreshBatches resetButton" icon="pi pi-times" (click)="resetAllFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv" *ngIf="!isVisible">
            <div class="ui-inputgroup" id="datePicker">
              <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
              <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
              </p-calendar>
            </div>
          </div>
          <div class="col-1 pt-2"></div>
          <div class="flex justify-content-between px-0">
            <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
              <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
            </span>
            <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
          </div>
        </div>

      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">

          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" id="puid-field" class="inputFields"/>
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10"
                (keydown.enter)="searchForPlate()" class="inputFields"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForPlate()"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10"
                (keydown.enter)="searchForSample()" class="inputFields"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;">
            <div class="col-12 flex headers">
              <h5>
                Plate: <strong>{{getPlateValue()}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers statusField" id="headerNonTop">
              <h5>
                Status: <strong> {{selectedPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop">
              <h5>
                Sender:<strong> {{selectedPlate?.sender}}</strong>
              </h5>
            </div>
            <div class="col-12 flex headers">
              <h5>
                Sample Type: <strong> {{selectedPlate?.sampleType}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop" style="margin-top:-14px" *ngIf="selectedPlate?.storagePlate">
              <h5>
                Storage:<strong> {{selectedPlate?.storage}} </strong>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class = "tableLHS1 tableCommentGap">
          <p-table [value]="plates" selectionMode="single" [(selection)]="tableSelectedRow"
          (onRowSelect)="fetchPlate($event)" (onRowUnselect)="removePlateSelection()" value="enabeled" [(ngModel)]="plateBtn" [loading]="loading">
          <ng-template pTemplate="header">
            <tr style="border: 1px solid lightgray;">
              <th scope="col" class="batch">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
              <th scope="col" class="status">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-plate>
            <tr [pSelectableRow]="plate">
              <td style="width: 30%;border: 1px solid lightgray;" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody text-break pr-0">
                  <span>{{plate?.lastUpdatedPlateID}}</span>
                  <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                  <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                  <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
              </td>
              <td style="width: 75%;border: 1px solid lightgray;" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody pr-0">
                {{plate?.status}}</td>
            </tr>
          </ng-template>
          </p-table>
        </div>
        <app-ma-comments-popup [extraction]="extraction" [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus"  [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" (backButtonEmitter)="hideDialog($event)"></app-ma-comments-popup>
      </div>
      <div class="col-9">
        <div class="col-6" id="tableDiv" *ngIf="!workflowSelectionDone">
          <table aria-describedby="Workflow selection" id="workflowSelection"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th scope="col">Workflow Selection</th>
              </tr>
            </thead>
            <tbody id="processingTableBody">
              <tr>
                <td id="processingTableBody" style="height: 12rem;">
                  <div class="col-12 parent">
                    <div class="col-12">
                      <div class="col-1">
                      </div>
                      <div class="col-11">
                        <span style="font-size: 1.5em;">Please enter the Plate-ID with which you want to continue!</span>
                      </div>
                    </div>
                    <div class="col-12 flex">
                      <div class="col-2"></div>
                      <div class="col-4 pr-0">
                          <button type="button" pButton class="LHbutton LHButton1" label="Plate ID"></button>
                      </div>
                      <div class="col-4 pl-0">
                          <input pInputText [(ngModel)]="workflowPlateID" class="SearchBox" size="30"
                            (keydown.enter)="workflowSelection()"/>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 flex" id="tableDiv" *ngIf="workflowSelectionDone">
          <table aria-describedby="Processing table" id="processingTable"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th *ngIf="showElement('PROCESS_STEP', '', 'LYSIS')" scope="col">Lysis</th>
                <th *ngIf="showElement('PROCESS_STEP', '', 'EXTRACTION')" scope="col">Extraction</th>
              </tr>
            </thead>
            <tbody>
            <tbody id="processingTableBody">
              <tr>
                <td *ngIf="showElement('PROCESS_STEP', '', 'LYSIS')" id="processingTableBody">
                  <div class="col-12 flex parent">
                    <div class="col-10 flex">
                      <div class="col-4 pr-0">
                          <button type="button" pButton class="LHbutton LHButton1" label="Machine"></button>
                      </div>
                      <div class="col-6 pl-0">
                          <input pInputText class="SearchBox" [(ngModel)]="lysisLiquidHandler" [disabled]="disableInputFields()" size="30"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <button type="button" pButton class="buttonsRound1 downLoadButton"
                        label="LOT"></button>
                    </div>
                  </div>
                  <div class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Start Lysis" class="buttonsRound startButton"
                        (click)="savePlateStatus('LYSIS_STARTED', 0, 'LYSIS', '', 0)" [disabled]="disableButton(0, 'LYSIS', '', 0)">
                      </button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('LYSIS')">
                      {{getProcessStepStartTimestamp('LYSIS') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepStartPuid('LYSIS')}}
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'INCUBATE_56C') && !isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 56°C" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_56C', 2, 'LYSIS', 'INCUBATE_56C', 0)"
                        [disabled]="disableButton(2, 'LYSIS', 'INCUBATE_56C', 0)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'STOP_INCUBATION_56C') && isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_56C', 2, 'LYSIS', 'STOP_INCUBATION_56C', 1)"
                        [disabled]="disableButton(2, 'LYSIS', 'STOP_INCUBATION_56C', 1)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS') && !isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'STOP_INCUBATION_56C')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'INCUBATE_56C_1H') && !isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_1H')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 56°C 1h" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_56C_1H', 2, 'LYSIS', 'INCUBATE_56C_1H', 0); firstIncubate()"
                        [disabled]="disableButton(2, 'LYSIS', 'INCUBATE_56C_1H', 0)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_1H')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'STOP_INCUBATION_56C_1H') && isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_1H')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_56C_1H', 2, 'LYSIS', 'STOP_INCUBATION_56C_1H', 1)"
                        [disabled]="disableButton(2, 'LYSIS', 'STOP_INCUBATION_56C_1H', 1)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS') && !isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_1H')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_1H')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_1H')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'STOP_INCUBATION_56C_1H')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'INCUBATE_56C_ON') && !isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_ON')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 56°C ON" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_56C_ON', 2, 'LYSIS', 'INCUBATE_56C_ON', 2)"
                        [disabled]="disableButton(2, 'LYSIS', 'INCUBATE_56C_ON', 2)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_ON')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'STOP_INCUBATION_56C_ON') && isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_ON')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_56C_ON', 2, 'LYSIS', 'STOP_INCUBATION_56C_ON', 3)"
                        [disabled]="disableButton(2, 'LYSIS', 'STOP_INCUBATION_56C_ON', 3)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS') && !isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_ON')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_ON')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_ON')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'STOP_INCUBATION_56C_ON')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'INCUBATE_56C_2H') && !isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_2H')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 56°C 2h" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_56C_2H', 2, 'LYSIS', 'INCUBATE_56C_2H', 4)"
                        [disabled]="disableButton(2, 'LYSIS', 'INCUBATE_56C_2H', 4)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_2H')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'LYSIS', 'STOP_INCUBATION_56C_2H') && isValidProcessStepActionPerformed('LYSIS', 'INCUBATE_56C_2H')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_56C_2H', 2, 'LYSIS', 'STOP_INCUBATION_56C_2H', 5)"
                        [disabled]="disableButton(2, 'LYSIS', 'STOP_INCUBATION_56C_2H', 5)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('LYSIS') && !isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_2H')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'INCUBATE_56C_2H')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('LYSIS', 'STOP_INCUBATION_56C_2H')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('LYSIS', 'STOP_INCUBATION_56C_2H')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('INPUT', '', 'LYSIS_PLATE_ID')" class="col-12 flex parent">
                    <div class="col-10 inputBox1">
                      <div class="col-4 pr-0">
                          <button type="button" pButton class="LHbutton LHButton1" label="Lysis Plate-ID"></button>
                      </div>
                      <div class="col-6 pl-0">
                          <input pInputText class="SearchBox" [(ngModel)]="selectedPlate.lysisPlateID" [disabled]="disableInputFields()" size="30"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 flex parent">
                    <div class="col-6 child">
                      <button pButton label="Complete Lysis" class="buttonsRound endButton"
                        (click)="savePlateStatus('LYSIS_COMPLETED',1, 'LYSIS', '', 0)"
                        [disabled]="disableButton(1, 'LYSIS', '', 0)"></button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('LYSIS')">
                      {{getProcessStepEndTimestamp('LYSIS') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepEndPuid('LYSIS')}}
                    </div>
                  </div>
                </td>
                <td *ngIf="showElement('PROCESS_STEP', '', 'EXTRACTION')" id="processingTableBody">
                  <div class="col-12 flex parent">
                    <div class="col-10 flex inputBox">
                      <div class="col-4 pr-0">
                          <button type="button" pButton class="LHbutton LHButton1" label="Machine"></button>
                      </div>
                      <div class="col-6 pl-0 ">
                          <input pInputText class="SearchBox" [disabled]="disableInputFields()" [(ngModel)]="extractionLiquidHandler" size="30"/>
                      </div>
                    </div>
                    <div class="col-2">
                      <button type="button" pButton class="buttonsRound1 downLoadButton"
                        label="LOT"></button>
                    </div>
                  </div>
                  <div class="col-12 flex parent inputBox2" >
                    <div class="col-6 child">
                      <button pButton label="Start Extraction" class="buttonsRound startButton"
                        (click)="savePlateStatus('EXTRACTION_STARTED', 0, 'EXTRACTION', '', 0)"
                        [disabled]="disableButton(0, 'EXTRACTION', '', 0)">
                      </button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('EXTRACTION')">
                      {{getProcessStepStartTimestamp('EXTRACTION') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepStartPuid('EXTRACTION')}}
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'INCUBATE_65C') && !isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_65C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 65°C" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_65C', 2, 'EXTRACTION', 'INCUBATE_65C', 0)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'INCUBATE_65C', 0)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_65C')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'STOP_INCUBATION_65C') && isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_65C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_65C', 2, 'EXTRACTION', 'STOP_INCUBATION_65C', 1)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'STOP_INCUBATION_65C', 1)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION') && !isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_65C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_65C')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_65C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'STOP_INCUBATION_65C')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'INCUBATE_56C_R') && !isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_56C_R')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 56°C" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_56C_R', 2, 'EXTRACTION', 'INCUBATE_56C_R', 0)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'INCUBATE_56C_R', 0)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_56C_R')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'STOP_INCUBATION_56C_R') && isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_56C_R')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_56C_R', 2, 'EXTRACTION', 'STOP_INCUBATION_56C_R', 1)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'STOP_INCUBATION_56C_R', 1)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION') && !isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_56C_R')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_56C_R')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_56C_R')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'STOP_INCUBATION_56C_R')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'INCUBATE_98C') && !isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_98C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Incubate 98°C" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('INCUBATE_98C', 2, 'EXTRACTION', 'INCUBATE_98C', 2)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'INCUBATE_98C', 2)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_98C')}} </span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'STOP_INCUBATION_98C') && isValidProcessStepActionPerformed('EXTRACTION', 'INCUBATE_98C')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Stop Incubation" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('STOP_INCUBATION_98C', 2, 'EXTRACTION', 'STOP_INCUBATION_98C', 3)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'STOP_INCUBATION_98C', 3)">
                      </button>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('EXTRACTION') && !isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_98C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'INCUBATE_98C')}}</span>
                    </div>
                    <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('EXTRACTION', 'STOP_INCUBATION_98C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('EXTRACTION', 'STOP_INCUBATION_98C')}}</span>
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'TRANSFER_LYSIS')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Transfer Lysis" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('TRANSFER_LYSIS', 2, 'EXTRACTION', 'TRANSFER_LYSIS', 2)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'TRANSFER_LYSIS', 2)">
                      </button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStepActionPerformed('EXTRACTION', 'TRANSFER_LYSIS')">
                      {{getProcessStepActionTimeStamp('EXTRACTION','TRANSFER_LYSIS') | date: 'dd.MM.yy HH:mm'}} <br/>
                      {{getProcessStepActionPuid('EXTRACTION','TRANSFER_LYSIS')}}
                    </div>
                  </div>
                  <div *ngIf="showElement('ACTION', 'EXTRACTION', 'PREPARE_OKTOPURE')" class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Prepare OKTOpure" class="buttonsRound VioletButtons"
                        (click)="savePlateStatus('PREPARE_OKTOPURE', 2, 'EXTRACTION', 'PREPARE_OKTOPURE', selectedProcessFlow === 'LYSIS_EXT_HAIR' ? 0 : 3)"
                        [disabled]="disableButton(2, 'EXTRACTION', 'PREPARE_OKTOPURE', selectedProcessFlow === 'LYSIS_EXT_HAIR' ? 0 : 3)">
                      </button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStepActionPerformed('EXTRACTION', 'PREPARE_OKTOPURE')">
                      {{getProcessStepActionTimeStamp('EXTRACTION','PREPARE_OKTOPURE') | date: 'dd.MM.yy HH:mm'}} <br/>
                      {{getProcessStepActionPuid('EXTRACTION','PREPARE_OKTOPURE')}}
                    </div>
                  </div>
                  <div *ngIf="showElement('INPUT', '', 'MA_PLATE_ID')" class="col-12 flex parent">
                    <div class="col-10 inputBox1">
                      <div class="col-4 pr-0">
                          <button type="button" pButton class="LHbutton LHButton1" label="MA Plate-ID"></button>
                      </div>
                      <div class="col-6 pl-0">
                          <input pInputText class="SearchBox" [disabled]="disableInputFields()" size="30"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 flex parent">
                    <div class="col-6 child">
                      <button pButton label="Complete Extraction" class="buttonsRound endButton"
                        (click)="savePlateStatus('EXTRACTION_COMPLETED',1, 'EXTRACTION', '', 0)"
                        [disabled]="disableButton(1, 'EXTRACTION', '', 0)"></button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('EXTRACTION')">
                      {{getProcessStepEndTimestamp('EXTRACTION') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepEndPuid('EXTRACTION')}}
                    </div>
                  </div>
                  <div *ngIf="qcNanoDrop" class="col-12 flex parent">
                    <div class="col-6 child">
                      <button pButton label="QCNanodrop Pass" class="buttonsRound passButton"
                        (click)="!detailedWorkflow ? qcNanoDropPass() : showQcPassPopUp()"
                        [disabled]="disableButton(0, 'NANODROP_PASS', '', 0)"
                        ></button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('NANODROP_PASS')">
                      {{getProcessStepStartTimestamp('NANODROP_PASS') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepStartPuid('NANODROP_PASS')}}
                    </div>
                  </div>
                  <div *ngIf="qcNanoDrop" class="col-12 flex parent">
                    <div class="col-6 child">
                      <button pButton label="QCNanodrop Fail" class="buttonsRound failButton"
                        (click)="toggleNanodropFail()" [disabled]="disableButton(0, 'NANODROP_PASS', '', 0)"
                        ></button>
                    </div>
                    <div class="col-4 sibling" *ngIf="isValidProcessStep('NANODROP_FAIL')">
                      {{getProcessStepStartTimestamp('NANODROP_FAIL') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepStartPuid('NANODROP_FAIL')}}
                    </div>
                  </div>
                  <div class="col-12 flex parent" >
                    <div class="col-6 child">
                      <button pButton label="Sample Placement" class="buttonsRound" (click)="samplePlacementPopUp = true">
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="popUpWithMachineAndChemicals" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh','min-width':'45vw'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex">
      <div class="col-4">
        <table aria-describedby="View Plates" class="table">
          <tr>
            <div class="mt-3 mb-3">
              <span style="font-weight: 700;">{{popUpWithMachineAndChemicalsHeader1}}</span>
              <br>
              <span style="font-weight: 700;">Plates count: {{multiUpdatePlateList.length}}</span>
            </div>
          </tr>
          <tr>
              <input pInputText name="plateId" [(ngModel)]="enteredPlateId" id="popUpWithMachineAndChemicals-popup-plateid" (keydown.enter)="checkPlate('LUP',multiPlateIdRequired[1])"
                placeholder="Scan Plates" />
          </tr>
          <tr *ngFor="let plate of multiUpdatePlateList; let myIndex=index;">
              <input pInputText name="plateId" [value]="plate"  id="plateid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(myIndex)"></button>
          </tr>
        </table>
      </div>
      <div class="col-1"></div>
      <div class="col-7">
        <table aria-describedby="View Plates" class="table">
          <tr>
            <div class="mt-3 mb-3">
              <span style="font-weight: 700;">{{popUpWithMachineAndChemicalsHeader2}}</span>
            </div>
          </tr>
          <tr>
            <div class="ui-inputgroup popUpInputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Equipment"></button>
              <input pInputText name="multi-update-machine-field" [(ngModel)]="multiLiquidHandler" (focusout)="checkMachineBarcode()"  (keydown.enter)="checkMachineBarcode()" size="12" class="inputFields border-right"/>
            </div>
          </tr>
          <tr>
            <div class="ui-inputgroup popUpInputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Lot {{popUpWithMachineAndChemicalsChemical}}"></button>
              <input pInputText name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical" (keydown.enter)="addLot()" [(ngModel)]="multiChemicalLot" size="12" class="inputFields border-right"/>
            </div>
            <div class="ui-inputgroup popUpInputClass" style="margin: 1%;" *ngFor="let lot of multiChemicalLotList; let myIndex=index;">
              <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Lot {{popUpWithMachineAndChemicalsChemical}}"></button>
              <input pInputText size="12" class="inputWidth multiLock border-left" name="lotId" [value]="lot" id="lotid" readonly />
              <button pButton icon="fa fa-times-circle" class="removeLots" (click)="deleteLotValue(myIndex)" style="width: 2rem"></button>
            </div>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 flex">
      <div class="col-5"></div>
      <div class="col-7">
          <button pButton label="Next Step" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
            [disabled]="((multiUpdatePlateList.length == 0) || (multiLiquidHandler == '') || (multiChemicalLotList.length == 0))">
          </button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="popUpWithDifferentMachine" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)" [style.width]="'800px'">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex">
      <table aria-describedby="View Plates" class="table">
        <tr *ngIf="multiSpinRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiSpinHeader}}</span>
            <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="multiSpinCheckboxValue" [(ngModel)]="multiSpinCheckboxValue" />
          </div>
        </tr>
        <tr *ngIf="multiShakeRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiShakeHeader}}</span> <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="multiShakeCheckboxValue || !multiSpinCheckboxValue" [(ngModel)]="multiShakeCheckboxValue" />
          </div>
        </tr>
        <tr>
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{popUpWithDifferentMachineHeader}}</span>
            <br>
            <span style="font-weight: 700;">Plates count: {{multiUpdatePlateInfoList.length}}</span>
          </div>
        </tr>
        <tr>
          <input pInputText class="input-padding" [disabled]="!multiShakeCheckboxValue" name="ovenId" [(ngModel)]="multiLiquidHandler" (keydown.enter)="checkMachineBarcode(multiPlateIdRequired[0], multiLysisPlateIdRequired[0], multiDnaPlateIdRequired[0])"
            (focusout)="checkMachineBarcode(multiPlateIdRequired[0], multiLysisPlateIdRequired[0], multiDnaPlateIdRequired[0])" id="popUpWithDifferentMachine-popup-machineid"  [placeholder]="popUpWithDifferentMachineEquipmentPlaceholder" />
          <input pInputText class="input-padding" [disabled]="!multiShakeCheckboxValue" name="plateId" *ngIf="multiPlateIdRequired[0]" [(ngModel)]="enteredPlateId" id="popUpWithDifferentMachine-popup-plateid" (keydown.enter)="checkPlate('LUP',multiPlateIdRequired[1])" placeholder="Scan Plate" />
          <input pInputText class="input-padding" [disabled]="!multiShakeCheckboxValue" name="lysisId" *ngIf="multiLysisPlateIdRequired[0]" [(ngModel)]="enteredLysisPlateId" id="popUpWithDifferentMachine-popup-lysis-plateid" (keydown.enter)="checkPlate('LYSIS',multiLysisPlateIdRequired[1])" placeholder="Scan Lysis Plate" />
          <input pInputText class="input-padding" [disabled]="!multiShakeCheckboxValue" name="magMixId" *ngIf="multiMagMixPlateIdRequired[0]" [(ngModel)]="enteredMagMixPlateId" id="popUpWithDifferentMachine-popup-magmix-plateid" (keydown.enter)="checkPlate('MAGMIX', multiMagMixPlateIdRequired[1])"  placeholder="Scan MagMix Plate" />
          <input pInputText class="input-padding" [disabled]="!multiShakeCheckboxValue" name="dnaId" *ngIf="multiDnaPlateIdRequired[0]" [(ngModel)]="enteredDnaPlateId" id="popUpWithDifferentMachine-popup-dna-plateid" (keydown.enter)="checkPlate('DNA',multiDnaPlateIdRequired[1])" placeholder="Scan DNA Plate" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
          <input pInputText class="input-padding" name="ovenId" [value]="plate.liquidHandler"  id="ovenid" readonly />
          <input pInputText class="input-padding" *ngIf="multiPlateIdRequired[0]" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
          <input pInputText class="input-padding" *ngIf="multiLysisPlateIdRequired[0]" name="lysisPlateId" [value]="plate.lysisPlateID"  id="lysis-plateid" readonly />
          <input pInputText class="input-padding" *ngIf="multiMagMixPlateIdRequired[0]" name="magMixPlateId" [value]="plate.magMixPlateID"  id="magMix-plateid" readonly />
          <input pInputText class="input-padding" *ngIf="multiDnaPlateIdRequired[0]" name="dnaPlateId" [value]="plate.dnaPlateID"  id="dna-plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(myIndex)"></button>
        </tr>
      </table>
    </div>
    <div *ngIf="multiUpdateStatus=='TRANSFER_LYSIS' || (multiUpdateStatus == 'EXTRACTION_STARTED' && selectedProcessFlow == 'LYSIS_EXT_HAIR')" class="col-12 flex">
      <div class="col-5"></div>
      <div class="col-7">
        <table id="scanTable" aria-describedby="View Plates" class="table">
          <thead style="display: none;">
            <th></th>
          </thead>
          <tr>
            <div class="ui-inputgroup popUpInputClass m-1">
              <button pButton class="theme-button noHover labelButton marginBottom" type="button" label="Lot BN1"></button>
              <input pInputText class="input-padding" name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical-bn1" (keydown.enter)="addBN1Lot()" [(ngModel)]="multiChemicalLotBN1" size="12" class="inputFields border-right"/>
            </div>
            <div class="ui-inputgroup popUpInputClass m-1" *ngFor="let BN1Lot of multiChemicalLotBN1List; let i = index;">
              <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Lot BN1"></button>
              <input pInputText  class="input-padding" size="12" class="inputFields border-left" name="bn1LotId" [value]="BN1Lot" id="bn1Lotid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput removeLots" (click)="deleteBN1LotValues(i)"></button>
            </div>
          </tr>
          <tr>
            <div class="ui-inputgroup popUpInputClass m-1">
              <button pButton class="theme-button noHover labelButton marginBottom" type="button" label="Lot TN1"></button>
              <input pInputText  class="input-padding" name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical-tn1" (keydown.enter)="addTN1Lot()" [(ngModel)]="multiChemicalLotTN1" size="12" class="inputFields border-right"/>
            </div>
            <div class="ui-inputgroup popUpInputClass m-1" *ngFor="let TN1Lot of multiChemicalLotTN1List; let i = index;">
              <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Lot TN1"></button>
              <input pInputText  class="input-padding" size="12" class="inputFields border-left" name="tn1Lotid" [value]="TN1Lot" id="tn1Lotid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput removeLots" (click)="deleteTN1LotValues(i)"></button>
            </div>
          </tr>
          <tr>
            <div class="ui-inputgroup popUpInputClass m-1">
              <button pButton class="theme-button noHover labelButton marginBottom" type="button" label="Lot TN2"></button>
              <input pInputText  class="input-padding" name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical-tn2" (keydown.enter)="addTN2Lot()" [(ngModel)]="multiChemicalLotTN2" size="12" class="inputFields border-right"/>
            </div>
            <div class="ui-inputgroup popUpInputClass m-1" *ngFor="let TN2Lot of multiChemicalLotTN2List; let i = index;">
              <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Lot TN2"></button>
              <input pInputText  class="input-padding" size="12" class="inputFields border-left" name="tn2LotId" [value]="TN2Lot" id="tn2Lotid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput removeLots" (click)="deleteTN2LotValues(i)"></button>
            </div>
          </tr>
          <tr>
            <div class="ui-inputgroup popUpInputClass m-1">
              <button pButton class="theme-button noHover labelButton marginBottom" type="button" label="Lot AMP"></button>
              <input pInputText  class="input-padding" name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical-amp" (keydown.enter)="addAMPLot()" [(ngModel)]="multiChemicalLotAMP" size="12" class="inputFields border-right"/>
            </div>
            <div class="ui-inputgroup popUpInputClass m-1" *ngFor="let AMPLot of multiChemicalLotAMPList; let i = index;">
              <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Lot AMP"></button>
              <input pInputText  class="input-padding" size="12" class="inputFields border-left" name="ampLotId" [value]="AMPLot" id="ampLotid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput removeLots" (click)="deleteAmpLotValues(i)"></button>
            </div>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 flex">
      <button pButton [label]="multiUpdateStatusLabel" *ngIf="multiUpdateStatusAndProcessFlow!='EXTRACTION_STARTED_LYSIS_EXT_EARTAG'"
        (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass" [disabled]="multiUpdatePlateList.length == 0">
      </button>
      <button pButton label="Next Step" *ngIf="multiUpdateStatusAndProcessFlow=='EXTRACTION_STARTED_LYSIS_EXT_EARTAG'"
        (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass" [disabled]="multiUpdatePlateList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="popUpWithMachine" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{popUpWithMachineHeader}}</span>
            <br>
            <span style="font-weight: 700;">Plates count: {{multiUpdatePlateInfoList.length}}</span>
          </div>
        </tr>
        <tr>
          <div class="ui-inputgroup popUpInputClass completeLysisPopUpLiquidHandler">
            <button pButton class="theme-button noHover labelButton" type="button" label="Equipment"></button>
            <input pInputText name="multi-update-machine-field" id="popUpWithMachine-popup-machineid" [(ngModel)]="multiLiquidHandler" (keydown.enter)="checkMachineBarcode(multiPlateIdRequired[0], multiLysisPlateIdRequired[0], multiDnaPlateIdRequired[0])"
              (focusout)="checkMachineBarcode(multiPlateIdRequired[0], multiLysisPlateIdRequired[0], multiDnaPlateIdRequired[0])"  size="12" class="inputFields"/>
          </div>
        </tr>
        <tr>
          <input pInputText *ngIf="multiPlateIdRequired[0]"  name="plateId" [(ngModel)]="enteredPlateId" id="popUpWithMachine-popup-plateid" (keydown.enter)="checkPlate('LUP',multiPlateIdRequired[1])" placeholder="Scan Orginal Plate" />
          <input pInputText *ngIf="multiLysisPlateIdRequired[0]" name="lysisPlateId" [(ngModel)]="enteredLysisPlateId" id="popUpWithMachine-popup-lysis-plateid" (keydown.enter)="checkPlate('LYSIS', multiLysisPlateIdRequired[1])" placeholder="Scan Lysis Plate" />
          <input pInputText *ngIf="multiDnaPlateIdRequired[0]" name="dnaPlateId" [(ngModel)]="enteredDnaPlateId" id="popUpWithMachine-popup-dna-plateid" (keydown.enter)="checkPlate('DNA', multiDnaPlateIdRequired[1])" placeholder="Scan DNA Plate" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
          <input pInputText *ngIf="multiPlateIdRequired[0]" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
          <input pInputText *ngIf="multiLysisPlateIdRequired[0]" name="lysisPlateId" [value]="plate.lysisPlateID"  id="lysisPlateid" readonly />
          <input pInputText *ngIf="multiDnaPlateIdRequired[0]" name="dnaPlateId" [value]="plate.dnaPlateID"  id="dnaPlateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(myIndex)"></button>
        </tr>
      </table>
    </div>
    <div class="col-12 flex">
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdatePlateList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="multiUpdatePopUp" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex">
      <div class="col-6">
        <table id="scanTable" aria-describedby="View Plates" class="table">
          <tr *ngIf="multiShakeRequired">
            <div class="mt-3 mb-3">
              <span style="font-weight: 700;">{{multiShakeHeader}}</span> <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="multiShakeCheckboxValue" [(ngModel)]="multiShakeCheckboxValue" />
            </div>
          </tr>
          <tr>
            <div class="mt-3 mb-3">
              <span style="font-weight: 700;">{{multiUpdatePopUpHeader1}}</span>
              <br>
              <span style="font-weight: 700;">Plates count: {{multiUpdatePlateList.length}}</span>
            </div>
          </tr>
          <tr>
            <input pInputText [disabled]="!multiShakeCheckboxValue" *ngIf="multiPlateIdRequired[0]" name="plateId" [(ngModel)]="enteredPlateId" id="multiUpdatePopUp-popup-plateid" (keydown.enter)="checkPlate('LUP',multiPlateIdRequired[1])" placeholder="Scan Plate" />
            <input pInputText [disabled]="!multiShakeCheckboxValue" *ngIf="multiLysisPlateIdRequired[0]" name="lysisPlateId" [(ngModel)]="enteredLysisPlateId" id="multiUpdatePopUp-popup-lysis-plateid" (keydown.enter)="checkPlate('LYSIS',multiLysisPlateIdRequired[1])" placeholder="Scan Lysis Plate"/>
            <input pInputText [disabled]="!multiShakeCheckboxValue" *ngIf="multiDnaPlateIdRequired[0]" name="dnaPlateId" [(ngModel)]="enteredDnaPlateId" id="multiUpdatePopUp-popup-dna-plateid" (keydown.enter)="checkPlate('DNA',multiDnaPlateIdRequired[1])" placeholder="Scan DNA Plate" />
          </tr>
          <tr *ngFor="let plate of multiUpdatePlateList; let myIndex=index;">
            <div style="display: flex; flex-direction: row;">
              <input pInputText name="plateId" [value]="plate"  id="plateid" readonly />
              <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteValue(myIndex)"></button>
            </div>
          </tr>
        </table>
      </div>
      <div class="col-1"></div>
      <div class="col-5">
        <table id="scanTable" aria-describedby="View Plates" class="table">
          <tr>
            <div class="mt-3 mb-3" style="font-weight: 700; white-space: pre-line">
              {{multiUpdatePopUpHeader2}}
            </div>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 flex">
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdatePlateList.length ==0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="QC Pass" [(visible)]="nanoDropPass" [modal]="true" position="top" (onHide)="closeMultiUpdatePopup()">
  <div class="col-12 flex">
    <table class="table">
      <thead>
        <tr>
          <th style="border: none;"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="border-0">
            <span><strong>Scan Plate</strong></span>
            <br>
            <span><strong>Plates count: {{multiUpdatePlateInfoList.length}} </strong></span>
          </td>
        </tr>
        <tr class="d-flex justify-content-center align-items-center">
          <td class="border-0">
            <input pInputText class="form-control" [(ngModel)]="enteredPlateId" placeholder=" Scan Plate-ID " id="qcpass-plate-id" (keydown.enter)="checkPlateForQC()"/>
          </td>
          <td class="border-0">
            <button pButton class="buttonsRound passButton" [disabled]="multiUpdatePlateInfoList.length === 0" label="QCNanodrop Pass" (click)="qcNanoDropPass()"></button>
          </td>
        </tr>
        <tr>
          <td class="border-0">
            <tr class="d-flex justify-content-start" *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
              <input pInputText class="inputWidth" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
              <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteValue(myIndex)"></button>
            </tr>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>

<p-dialog header="QC Fail" [(visible)]="nanoDropFail" [modal]="true" position="top" (onHide)="closeMultiUpdatePopup()">
  <div style="display: flex; flex-direction: column; align-items: center;" class="col-12 flex">
    <table class="table">
      <thead>
        <tr>
          <th style="border: none;"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="display: flex; flex-direction: column;" class="col-6 border-0">
            <span style="white-space: nowrap;"><strong>Scan Plate</strong></span>
            <br>
            <span style="white-space: nowrap;"><strong>Plates count: {{multiUpdatePlateInfoList.length}}</strong></span>
          </td>
          <td class="col-5 border-0">
            <span><strong>Redo Reason:</strong></span>
          </td>
          <td class="border-0"><div></div></td>
        </tr>
        <tr>
          <td class="col-6 border-0">
            <input pInputText class="form-control" [(ngModel)]="enteredPlateId" placeholder=" Scan Plate-ID" id="qcfail-plate-id" (keydown.enter)="checkPlateForQC()">
          </td>
          <td class="col-5 border-0">
            <p-dropdown #popUpRedoSelector [options]="qcFailRedoList" [(ngModel)]="selectedRedoReason" [disabled]="qcFailRedoList.length === 0"
            optionLabel="label" optionValue="value" placeholder="Select Reason" (onHide)="addPlateForQCFail()"></p-dropdown>
          </td>
          <td class="border-0"><div></div></td>
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
          <td class="col-6 border-0">
              <input pInputText class="inputWidth" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
          </td>
          <td class="col-5 border-0">
            <input pInputText class="inputWidth" name="redoID" [value]="plate.redoLabel" id="plateid" readonly/>
          </td>
          <td class="border-0">
            <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteValue(myIndex)"></button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-12 flex d-flex justify-content-end">
      <button pButton class="buttonsRound failButton" label="QC Fail" [disabled]="multiUpdatePlateInfoList.length === 0" (click)="reRun()"></button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Sample Placement" id="sample-placement-dialog" [draggable]="false" [resizable]="false" [closable]="false" [(visible)]="samplePlacementPopUp" [modal]="true" position="top" (onHide)="samplePlacementPopUp = false" [style]="{'max-width':'80vw'}">
  <app-ma-sample-placement [processFlowNameProcessFlowMap]="processFlowNameProcessFlowMap" [selectedProcessFlows]="selectedProcessFlows" [isProcessUpdateProxied]="isProcessUpdateProxied" (onClose)="samplePlacementPopUp = false"></app-ma-sample-placement>
</p-dialog>
